import React from 'react';
import { Image, Navbar, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import {
  HOME_FEED, NOTIFICATION_ROUTE,
} from '../../constants/routes.constants';
import { useAuth } from '../auth/Auth';
import logo from '../../assets/logo/logo-53x53.svg';
import userAvtr from '../../assets/images/uni.svg';
import TaletreeHeader from './TaletreeHeader';
import ProfileMenu from './ProfileMenu';
import './css/camp.header.scss';
import { getUserNotificationChar } from '../../utils/camp.utils';

const handleClick = () => {
  history.push(NOTIFICATION_ROUTE)
}

const CampHeaderDependant = () => {
  const { logout, dependent } = useAuth();
  return (
    <TaletreeHeader className="camp-header kid">
      <div className='head-first-box'>
      <LinkContainer to={HOME_FEED}>
        <Navbar.Brand>
          <Image src={logo} className="logo" />
        </Navbar.Brand>
      </LinkContainer>
      <div className='headerUserNotification' onClick={handleClick}>
      <Image src={getUserNotificationChar(dependent)} className="User Avtar" />
        <span className='userNotification'>Hey {dependent !== null && dependent.first_name}, I want to talk to you.</span>
      </div>
      </div>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse
        id="responsive-navbar-nav"
        className="justify-content-end"
      >
        <Nav className="ml-auto align-items-md-center navbar-sub navbar-custom">
          <Nav.Link
            className="px-4 camp-header-link logout"
            onClick={() => logout()}
          >
            Logout
          </Nav.Link>
          <div className="profile-menu-header-container">
          <ProfileMenu />
          </div>
        </Nav>
      </Navbar.Collapse>
    </TaletreeHeader>
  );
};

export default CampHeaderDependant;
